import React from 'react';
import styles from '../DescriptionEditor.module.scss';

/** Chain-link icon for the link control */
export function LinkIcon({ className }) {
  return (
    <svg
      className={className || styles.chromeLinkSvg}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M10 13a5 5 0 0 1 0-7l1-1a5 5 0 0 1 7.07 7.07l-.65.64M14 11a5 5 0 0 1 0 7l-1 1a5 5 0 0 1-7.07-7.07l.64-.65"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** "Text" field prefix icon */
export function TextLinesIcon({ className }) {
  return (
    <svg
      className={className || styles.chromeFieldSvg}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M4 7h16M4 12h10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
